import React from 'react';
import { useTheme } from 'styled-components';
import { IconProps } from './types';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function ArrowToBracketIcon({ color: colorProp }: IconProps) {
  const theme = useTheme();

  const color = colorProp || theme.colors.iconIconPrimaryPressedSecondary2100;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M9.42188 4.45312L16.1719 11.2031C16.6125 11.6438 16.6125 12.3562 16.1719 12.7922L9.42188 19.5469C9.09844 19.8703 8.61563 19.9641 8.19375 19.7906C7.77188 19.6172 7.5 19.2047 7.5 18.75V15H2.25C1.00781 15 0 13.9922 0 12.75V11.25C0 10.0078 1.00781 9 2.25 9H7.5V5.25C7.5 4.79531 7.77188 4.38281 8.19375 4.20938C8.61563 4.03594 9.09844 4.13438 9.42188 4.45312ZM9 17.8453L14.8453 12L9 6.15469V9.75C9 10.1625 8.6625 10.5 8.25 10.5H2.25C1.8375 10.5 1.5 10.8375 1.5 11.25V12.75C1.5 13.1625 1.8375 13.5 2.25 13.5H8.25C8.6625 13.5 9 13.8375 9 14.25V17.8453ZM15.75 21H19.5C21.1547 21 22.5 19.6547 22.5 18V6C22.5 4.34531 21.1547 3 19.5 3H15.75C15.3375 3 15 2.6625 15 2.25C15 1.8375 15.3375 1.5 15.75 1.5H19.5C21.9844 1.5 24 3.51562 24 6V18C24 20.4844 21.9844 22.5 19.5 22.5H15.75C15.3375 22.5 15 22.1625 15 21.75C15 21.3375 15.3375 21 15.75 21Z"
        fill={color}
      />
    </svg>
  );
}

export default ArrowToBracketIcon;
